/**************************************************
 * Nombre:       MenuLateral
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Drawer, Grid, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {theme} from "../../Tema";
import {Category, Close, LocalOffer} from '@mui/icons-material'
import Item_Categoria from "./SubComponentes/Item_Categoria";
import {contexData} from "../../App";
import ScrollBar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {contarColeccion} from "../../Servicios/BD/Contadores/contarColeccion";
import {useNavigate} from "react-router-dom";

const MenuLateral = () => {
    const {masSM} = useResponsive()
    const cData = useContext(contexData)
    const navigate = useNavigate()
    const categorias = useContext(contexData).categorias
    const [escogido, setEscogido] = useState({})
    const [num, setNum] = useState(0)


    useEffect(() => {
        contarColeccion({coleccion: 'productos'}).then((dox) => {
            setNum(dox.data)
        })
    }, []);
    return (
        <Drawer open={cData.openCategorias} variant={!masSM ? 'temporary' : 'permanent'}
                onClose={() => cData.setOpenCategorias(false)}
        >
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={12}
                sx={{width: 280, overflow: 'hidden',}}
            >


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={12}
                    sx={{p: 2, mt: !masSM ? 0 : 10}}
                >


                    <Grid container size={{xs: 6, sm: 12, md: 8}} sx={{pb: 2}}>
                        <Button
                            onClick={() => {
                                !masSM && cData.setOpenCategorias(false)
                            }
                            }
                            variant={'text'} startIcon={!masSM ? <Close/> : <Category/>}
                            sx={{px: 0, color: '#000000'}}
                        >Categorias</Button>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 12, md: 4}} sx={{justifyContent: 'flex-end', pb: 2}}>
                        <Typography
                            sx={{fontSize: 12, color: theme.palette.primary.main, lineHeight: 1, textAlign: 'right'}}>
                            {`+${num} Productos`}
                        </Typography>
                    </Grid>

                    <ScrollBar dir={'rigth'} options={{suppressScrollX: true, maxScrollbarLength: 150}}
                               style={{marginRight: -16, paddingRight: 16, maxHeight: '82vh'}}>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            {categorias.map((it, index) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                        <Item_Categoria item={it} escogido={escogido} setEscogido={setEscogido}/>
                                    </Grid>
                                )
                            })}


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={12}
                                sx={{
                                    color: theme.palette.info.main,
                                    borderRadius: 4,
                                    border: 1,
                                    borderColor: theme.palette.info.main,
                                    paddingX: 2,
                                    paddingY: 2,
                                    boxShadow: 2,
                                    cursor: 'pointer',
                                    mt: 3,
                                    mb: 10
                                }}>


                                <Grid container size={3}>
                                    <LocalOffer sx={{width: 32, height: 32, fill: theme.palette.info.main}}/>
                                </Grid>

                                <Grid container size={9} sx={{ml: -1}}>
                                    <Grid
                                        onClick={() => navigate('/Ofertas')}
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>


                                        <Grid item container size={12} sx={{justifyContent: 'flex-start'}}>
                                            <Typography
                                                sx={{
                                                    fontSize: 20,
                                                    fontWeight: 900,
                                                    textAlign: 'left',
                                                    lineHeight: 1.1
                                                }}>
                                                OFERTAS
                                            </Typography>
                                        </Grid>

                                        <Grid container size={12} sx={{marginTop: 0}}>
                                            <Typography
                                                sx={{fontSize: 14, fontWeight: 600, textAlign: 'left'}}>
                                                Por tiempo limitado
                                            </Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>


                            </Grid>

                        </Grid>


                    </ScrollBar>


                </Grid>


            </Grid>
        </Drawer>
    )

}
export default MenuLateral


const CATEGORIAS = [
    'Proteina',
    'Carbohidratos'
]